import "./Home.module.css";
import EnTete from "@/reusable_sections/Header";
import TransformezVotreMaisonEnTouteSimplicite from "./sections/TransformezVotreMaisonEnTouteSimplicite";
import NosServices from "./sections/NosServices";
import AidesFinancieres from "./sections/AidesFinancieres";
import PourquoiChoisirBeTravaux from "./sections/PourquoiChoisirBeTravaux";
import TransformationsElegantes from "./sections/TransformationsElegantes";
import ServicesUrgence from "./sections/ServicesUrgence";
import PourLesProfessionnels from "./sections/PourLesProfessionnels";
import RecevoirMonDevisPersonnalise from "./sections/RecevoirMonDevisPersonnalise";
import PiedDePage from "@/reusable_sections/Footer";
import ConversationalQuoteForm from "./sections/ConversationalQuoteForm";
export default function HomePage() {
  return <div>
      <EnTete />
      <TransformezVotreMaisonEnTouteSimplicite />
      <ConversationalQuoteForm />
      <NosServices />
      <AidesFinancieres />
      <PourquoiChoisirBeTravaux />
      <TransformationsElegantes />
      <ServicesUrgence />
      <PourLesProfessionnels />
      <RecevoirMonDevisPersonnalise />
      <PiedDePage />
    </div>;
}